<div class="loader-4h loader-4h--{{ size }}"
     role="status"
     aria-live="polite"
     [style.minHeight]="minHeight"
     @fadeInOut>

  <div class="loader-4h__icons" aria-hidden="true">
    <img src="/assets/icons/heart.svg"   class="loader-4h__icon" alt="" />
    <img src="/assets/icons/head.svg"    class="loader-4h__icon" alt="" />
    <img src="/assets/icons/hands.svg"   class="loader-4h__icon" alt="" />
    <img src="/assets/icons/results.svg" class="loader-4h__icon" alt="" />
  </div>

  <div class="loader-4h__percent" *ngIf="showPercent" [@counterPop]="percent">
    {{ percent }}<span class="loader-4h__percent-sign">%</span>
  </div>

  <div class="loader-4h__counter" *ngIf="hasCounter">
    <span class="loader-4h__counter-num" [@counterPop]="count">{{ count }}</span>
    <span class="loader-4h__counter-sep">/</span>
    <span class="loader-4h__counter-tot">{{ total }}</span>
  </div>

  <p class="loader-4h__label" *ngIf="label">{{ label }}</p>

</div>
